// A panel which opens and allows admins to edit content
import React from 'react'
import PropTypes from 'prop-types'
import './cms_panel_styles.scss'

const EMPTY_CONTENT = {
  value_en: 'Loading...',
  value_es: 'Loading...',
  platform: '(platform)',
}

// Slide-in form where editors can change CMS content, preview it, and then save to DB.
class CmsPanel extends React.Component {
  constructor(props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handlePreview = this.handlePreview.bind(this)

    this.state = {
      prevContentPage: null,
      prevContentKey: null,
      editingElement: props.editingElement,
      ...EMPTY_CONTENT,
    }
  }

  componentDidMount() {
    this.fetchContentsIfIdChanged()
  }

  componentDidUpdate() {
    this.fetchContentsIfIdChanged()
  }

  handleChange(event) {
    const stateKey = event.target.name
    this.setState({ [stateKey]: event.target.value })
  }

  handleSubmit(event) {
    event.preventDefault()

    // update Content
    const admin_content_update_url = `/admin/content?page=${this.props.contentPage}&key=${this.props.contentKey}`
    fetch(admin_content_update_url, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        content: {
          value_en: this.state.value_en,
          value_es: this.state.value_es,
        },
      }),
    }).then((response) => {
      if (response.status === 200) {
        document.location.reload()
      } else {
        console.warn('error trying to save content:', response)
      }
    })
  }

  handlePreview(event) {
    event.preventDefault()

    const stateKey = event.target.name // i.e. value_en or value_es
    const markdown_text = this.state[stateKey]
    const url = '/admin/content/markdown' // convert markdown to HTML
    return fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ text: markdown_text }),
    })
      .then((response) => response.json())
      .then((data) => {
        const htmlPreview = data.html
        this.setState({ htmlPreview })
        this.props.editingElement.innerHTML = htmlPreview
      })
  }

  fetchContentsIfIdChanged() {
    if (
      this.state.prevContentPage !== this.props.contentPage ||
      this.state.prevContentKey !== this.props.contentKey
    ) {
      // has ID changed?
      this.fetchContent(this.props.contentPage, this.props.contentKey)
      this.setState({
        prevContentPage: this.props.contentPage,
        prevContentKey: this.props.contentKey,
        ...EMPTY_CONTENT,
      })
    }
  }

  fetchContent(contentPage, contentKey) {
    const admin_content_show_url = `/admin/content?page=${contentPage}&key=${contentKey}`
    console.debug('!!! fetching content from', admin_content_show_url)
    return fetch(admin_content_show_url)
      .then((response) => response.json())
      .then((contentData) => {
        this.setState({
          value_en: contentData.value_en,
          value_es: contentData.value_es,
          platform: contentData.platform,
        })
      })
  }

  render() {
    const page_content_index_url = `/active_admin/contents/?q[page_eq]=${this.props.contentPage}`
    return (
      <div className="CmsPanel">
        <p> platform: {this.state.platform} </p>
        <p>
          {' '}
          page & key:
          <a href={page_content_index_url}>
            {' '}
            {this.props.contentPage} &gt; {this.props.contentKey}{' '}
          </a>
        </p>

        <form onSubmit={this.handleSubmit}>
          <label>
            <div> English: </div>
            <textarea
              name="value_en"
              value={this.state.value_en}
              onChange={this.handleChange}
              className="value"
            />
          </label>
          <button onClick={this.handlePreview} name="value_en" type="submit">
            {' '}
            Preview{' '}
          </button>

          <label>
            <div> Spanish: </div>
            <textarea
              name="value_es"
              value={this.state.value_es}
              onChange={this.handleChange}
              className="value"
            />
          </label>
          <button onClick={this.handlePreview} name="value_es" type="submit">
            {' '}
            Preview{' '}
          </button>

          <div className="save_button_box">
            <input className="save_button" type="submit" value="Save" />
          </div>
        </form>

        {this.state.htmlPreview && (
          <div>
            <label> Preview: </label>
            <div
              className="html_preview"
              // eslint-disable-next-line @eslint-react/dom-no-dangerously-set-innerhtml
              dangerouslySetInnerHTML={{ __html: this.state.htmlPreview }}
            />
          </div>
        )}
      </div>
    )
  }
}
CmsPanel.propTypes = {
  contentPage: PropTypes.string.isRequired, // of Content row in DB or YML file
  contentKey: PropTypes.string.isRequired,
  editingElement: PropTypes.object.isRequired, // DOM Element which will be filled for Preview
}

export default CmsPanel
